import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-lot-meta #lot_number { width: 14rem; }
			#sm-lot-meta #manufacture_date, #sm-lot-meta #expiration_date { width: 10rem; }
			#sm-lot-meta #program_id { width: 18rem; }
			#sm-lot-meta #selected_rows_preview, #sm-lot-meta #selected_lots_preview { width: 40rem; max-width: 100%; }
			#sm-lot-meta #sm-lot-scope-box { max-width: 40rem; }
		</style>
		<form id="sm-lot-meta" class="form" autocomplete="off">
			<div class="title">Lote / datas / programa</div>
			<p id="sm-lot-hint" class="mts muted" style="max-width:40rem"></p>
			<div class="fsb">
				<label>Linhas selecionadas (SKU · lote fab. · posição)
					<textarea id="selected_rows_preview" rows="3" disabled></textarea>
				</label>
				<label>Alcance por SKU + lote fab.
					<textarea id="selected_lots_preview" rows="3" disabled></textarea>
				</label>
			</div>
			<div id="sm-lot-scope-box" class="mtm" style="display:none">
				<label class="fsb" style="align-items:flex-start;gap:0.5rem;cursor:pointer">
					<input id="only_selected_lines" type="checkbox" style="margin-top:0.2rem">
					<span><strong>Alterar somente nas linhas selecionadas</strong> — o sistema cria um lote interno separado automaticamente quando o mesmo SKU e lote fab. existem em outros paletes (você não precisa informar identificador técnico).</span>
				</label>
			</div>
			<div class="fsb mtl">
				<label>Lote fab.
					<input id="lot_number" type="text" placeholder="Deixe em branco para não alterar">
				</label>
				<label>Fabricação
					<input id="manufacture_date" type="text" placeholder="aaaa-mm-dd">
				</label>
				<label>Validade
					<input id="expiration_date" type="text" placeholder="aaaa-mm-dd">
				</label>
				<label title="Programas da mesma empresa das linhas selecionadas">Programa
					<input id="program_id" type="text" list="programs_list" placeholder="Selecione o programa">
				</label>
			</div>
			<datalist id="programs_list"></datalist>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Aplicar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-lot-meta',
		/** Empresa das linhas — preenchida pelo Gerenciamento antes do init. */
		_programsCompanyId: null,
		init(formset) {
			formset.form.eraseValues();
			const companyId = this._programsCompanyId;
			if (companyId)
			{
				formset.loadList('#programs_list', 'programs', {
					labels: ['name'],
					value: 'id',
					range: IDBKeyRange.bound([companyId, ''], [companyId, '\uffff']),
					index: 2,
				});
			}
			else
			{
				const node = document.querySelector(`${this.selector} #programs_list`);
				if (node)
					node.innerHTML = '';
			}
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#selected_rows_preview' }, types: [] },
		{ properties: { selector: '#selected_lots_preview' }, types: [] },
		{ properties: { selector: '#only_selected_lines' }, types: [ types.checkbox() ] },
		{ properties: { selector: '#lot_number' }, types: [ types.name() ] },
		{ properties: { selector: '#manufacture_date' }, types: [ types.date() ] },
		{ properties: { selector: '#expiration_date' }, types: [ types.date() ] },
		{ properties: { selector: '#program_id' }, types: [ types.datalist() ] },
	],
};
